import React, { useMemo } from "react";

// Cheap DOM-based twinkling stars + shooting stars background
export default function StarField({ count = 120, shootingStars = 6 }) {
  const stars = useMemo(() => {
    const arr = [];
    for (let i = 0; i < count; i++) {
      arr.push({
        top: Math.random() * 100,
        left: Math.random() * 100,
        d: 2 + Math.random() * 4,
        s: Math.random() < 0.15 ? 3 : Math.random() < 0.4 ? 2 : 1,
      });
    }
    return arr;
  }, [count]);

  const shots = useMemo(() => {
    const arr = [];
    for (let i = 0; i < shootingStars; i++) {
      arr.push({
        top: 5 + Math.random() * 55, // upper half of screen
        left: -20 + Math.random() * 40, // start off-screen or near left
        delay: Math.random() * 14, // stagger
        duration: 3.5 + Math.random() * 2.5,
        length: 120 + Math.random() * 160,
        angle: 12 + Math.random() * 18, // diagonal angle
      });
    }
    return arr;
  }, [shootingStars]);

  return (
    <div className="stars-bg" aria-hidden="true">
      {stars.map((st, i) => (
        <span
          key={i}
          className="star"
          style={{
            top: `${st.top}%`,
            left: `${st.left}%`,
            width: `${st.s}px`,
            height: `${st.s}px`,
            "--d": `${st.d}s`,
            animationDelay: `${(i % 7) * 0.4}s`,
          }}
        />
      ))}
      {shots.map((s, i) => (
        <span
          key={`shot-${i}`}
          className="shooting-star"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: `${s.length}px`,
            "--angle": `${s.angle}deg`,
            "--dur": `${s.duration}s`,
            animationDelay: `${s.delay}s`,
          }}
        />
      ))}
      <div className="grain-overlay" />
    </div>
  );
}
